import { useState, useEffect } from 'react';
import { toAbsoluteUrl } from '../../../_metronic/helpers';

/**
 * WelcomePopup component displays a welcome message and banner for the Mitr Loyalty Program.
 * Shows a popup on first visit and hides after user confirmation.
 */
const WelcomePopup = ({ projectData }) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const welcomePopupShown = localStorage.getItem('welcomePopup');
        if (!welcomePopupShown) {
            setShow(true);
        }
    }, []);

    const closePopup = () => {
        setShow(false);
        localStorage.setItem('welcomePopup', 'true');
    };

    // Inline styles for the offcanvas component
    const offcanvasStyles = {
        position: 'fixed',
        bottom: show ? '0' : '-100%', // Sliding from bottom
        left: '50%',
        transform: 'translateX(-50%)',
        width: '100%',
        maxWidth: '500px', // Limit width on larger screens
        height: '300px',
        backgroundColor: '#fff',
        borderRadius: '15px 15px 0 0',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
        transition: 'bottom 0.5s ease-in-out', // Slide up transition
        zIndex: 1050,
    };

    const overlayStyles = {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        opacity: show ? 1 : 0,
        visibility: show ? 'visible' : 'hidden',
        transition: 'opacity 0.3s ease-in-out',
        zIndex: 1040,
    };

    return (
        <>
            {show && (
                <div className="App">
                    {/* Overlay */}
                    <div style={overlayStyles} onClick={closePopup}></div>

                    {/* Custom Offcanvas */}
                    <div style={{ ...offcanvasStyles, marginBottom: '55px' }}>
                        <div className="card rounded-5">
                            <div className="card-body">
                                <p>Welcome to the Mitr Loyalty Program</p>
                                <div>
                                    <img
                                        src={projectData?.banner ? toAbsoluteUrl(projectData?.welcome_image) : ''}
                                        alt="Banner"
                                        style={{ width: '100%', height: 'auto' }}
                                        className="img-fluid rounded"
                                    />
                                </div>
                                <div className="mt-4">
                                    <button onClick={closePopup} className="btn btn-sm btn-danger w-100 py-4">
                                        Got it!
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default WelcomePopup;
